import { getDoc, setDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

export const getUserById = async (email) => {
  if (!!email) {
    const studentDoc = doc(db, "Users", email);
    const data = await getDoc(studentDoc);
    return data.data();
  } else {
    console.log("error get by id");
  }
};
export const setUserCharacter = async (data, userId) => {
  const addField = await setDoc(doc(db, "Users", userId), data);
  return addField;
};

export const setCompleteWeek = async (data, userId) => {
  const addField = await setDoc(doc(db, "Users", userId), data);
  return addField;
};
